import React, { useMemo, useState } from "react";
import NoData from "../Info/NoData";
import FormFieldSet from "../FormFields/FormFieldSet";
import { buildTreeModel } from "./supportFiles/buildTreeModel";
import { layoutLeftToRight } from "./supportFiles/layoutLeftToRight";
import TreeHierarchyChart from "./supportFiles/TreeHierarchyChart";
import RootJobsModal from "./supportFiles/RootJobsModal";
import BdmJobsModal from "./supportFiles/BdmJobsModal";
import InternalSubmissionModal from "./supportFiles/InternalSubmissionModal";
import StageModal from "./supportFiles/StageModal";

const TreeHierarchy = ({
  countsData = [],
  data = [],
  duration = {
    from: new Date(),
    to: new Date(),
  },
  onDurationChange = () => { },
  onNodeClick = () => { },
  page,
  limit,
  setPage,
  handleLimitChange,
  onStageNumberChange,
  tab2Data,
  tab3Data,
  tab2TotalCount,
  tab3TotalCount,
  loading,
  viewMode = "scroll",
  onSubmissionClick,
  submissionClickData,
  subPage,
  subLimit,
  subSetPage,
  subHandleLimitChange
}) => {

  const hasData = countsData?.[0]?.totalJobsCount > 0 ? true : false;
  // const model = useMemo(() => buildTreeModel(data), [data]);
  const layout = useMemo(() => layoutLeftToRight(countsData), [countsData]);
  const [isRootModalOpen, setIsRootModalOpen] = useState(false);
  const [isBdmModalOpen, setIsBdmModalOpen] = useState(false);
  const [isInternalModalOpen, setIsInternalModalOpen] = useState(false);
  const [isStageModalOpen, setIsStageModalOpen] = useState(false);
  const [activeEmployeeId, setActiveEmployeeId] = useState(null);
  const [activeEmployeeIdForStage, setActiveEmployeeIdForStage] =
    useState(null);
  const [activeStageName, setActiveStageName] = useState(null);
  const [selectedNodeId, setSelectedNodeId] = useState(null);

  const handleNodeClick = (payload) => {
    if (payload?.type === "root") setIsRootModalOpen(true);
    if (payload?.type === "employee") {
      setActiveEmployeeId(payload?.employeeId ?? null);
      setIsBdmModalOpen(true);
    }
    if (payload?.type === "stage") {
      const stageName = payload?.stageName ?? null;
      const allowed =
        stageName === "Internal Submission" ||
        stageName === "Client Submissions" ||
        stageName === "Aggrements" ||
        stageName === "Interview Round 1" ||
        stageName === "Interview Round 2" ||
        stageName === "Interview Round 3" ||
        stageName === "Placements";

      if (allowed) {
        setActiveEmployeeIdForStage(payload?.employeeId ?? null);
        setActiveStageName(stageName);
        if (stageName === "Internal Submission") setIsInternalModalOpen(true);
        else setIsStageModalOpen(true);
      }
    }
    if (typeof onNodeClick === "function") onNodeClick(payload);
  };

  return (
    <div className="w-full h-full flex flex-1 flex-col overflow-hidden gap-2 ">
      <div className="HeaderTool flex items-center justify-between">
        <div className="min-w-[200px]"></div>
        <div className="min-w-[300px]">
          <FormFieldSet
            title="Select Date"
            noTitle
            type="datepickerRange"
            value={duration}
            onChange={onDurationChange}
            maxDate={new Date()}
          />
        </div>
      </div>
      {!hasData ? (
        <div>
          <NoData title="No data for selected range" />
        </div>
      ) : (
        <div className="w-full flex-1 overflow-hidden">
          <TreeHierarchyChart
            layout={layout}
            onNodeClick={handleNodeClick}
            selectedNodeId={selectedNodeId}
            onNodeSelect={setSelectedNodeId}
            viewMode={viewMode}
          />
        </div>
      )}
      <RootJobsModal
        isOpen={isRootModalOpen}
        onClose={() => {

          setIsRootModalOpen(false);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        totalCount={countsData?.[0]?.totalJobsCount ?? 0}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
      />
      <BdmJobsModal
        isOpen={isBdmModalOpen}
        onClose={() => {
          setIsBdmModalOpen(false);
          setActiveEmployeeId(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeId}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        loading={loading}
        onSubmissionClick={onSubmissionClick}
        submissionClickData={submissionClickData}
        subPage={subPage}
        subLimit={subLimit}
        subSetPage={subSetPage}
        subHandleLimitChange={subHandleLimitChange}
      />
      <InternalSubmissionModal
        isOpen={isInternalModalOpen}
        onClose={() => {
          setIsInternalModalOpen(false);
          setActiveEmployeeIdForStage(null);
          setActiveStageName(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeIdForStage}
        // duration={duration}
        stageName={activeStageName || "Internal Submission"}
        onStageNumberChange={onStageNumberChange}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        tab2Data={tab2Data}
        tab3Data={tab3Data}
        tab2TotalCount={tab2TotalCount}
        tab3TotalCount={tab3TotalCount}
        loading={loading}
      />
      <StageModal
        isOpen={isStageModalOpen}
        onClose={() => {
          setIsStageModalOpen(false);
          setActiveEmployeeIdForStage(null);
          setActiveStageName(null);
          setSelectedNodeId(null);
          setPage(1)
          handleLimitChange(25)
        }}
        data={data}
        employeeId={activeEmployeeIdForStage}
        //duration={duration}
        stageName={activeStageName}
        onStageNumberChange={onStageNumberChange}
        totalCount={countsData}
        page={page}
        limit={limit}
        setPage={setPage}
        handleLimitChange={handleLimitChange}
        tab2Data={tab2Data}
        tab3Data={tab3Data}
        tab2TotalCount={tab2TotalCount}
        tab3TotalCount={tab3TotalCount}
        loading={loading}
      />
    </div>
  );
};

export default TreeHierarchy;
